import { buildFullFileUrl } from "@/api/moudules/file";

export function toResourceUrl(url: string, defaultUrl: string) {
    if (url) {
        return buildFullFileUrl(url)
    }
    return defaultUrl
}
